import styled from "styled-components";

export const Container = styled.div`
  /* min-height: 100vh;
  width: 100vw; */

  /* margin-top: 50px; */
  /* padding: 0 50px; */
  padding: 1rem;

  display: flex;
  flex-direction: column;
  align-items: center;
  /*  justify-content: center; */

  background: #fff;
  overflow-x: scroll;
`;

export const Box = styled.div`
  /* min-height: 60vh;
  min-width: 80vw; */

  padding: 50px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background: #fff;
  box-shadow: 0 0 2px 2px rgba(34, 36, 38, 0.15);

  button {
    min-width: 100px;
  }
`;

export const Header = styled.header`
  font-family: "Montserrat";
  font-weight: 600;
  font-size: 26px;
  line-height: 1em;

  /* text-transform: uppercase; */

  color: #000;

  margin: 30px;
`;

export const FormBlock = styled.div`
  > p {
    font-size: 18px;
    font-weight: 500;
  }

  span {
    font-size: 14px;
    font-weight: 400;
  }

  margin-bottom: 30px;
`;

export const TableContainer = styled.section`
  margin-top: 3rem;
  margin-left: auto;
`;

export const Destino = styled.div`
  display: flex;
  flex-direction: row;

  & > p {
    margin-right: 20px;
  }
`;
